import { LoadCurve } from '@/dto/scenario/load/LoadCurve';
import { DtoExt } from '@/classes/scenario/DtoExt';

export class LoadCurveExt extends DtoExt {

  public static fromDto(dto: LoadCurve): LoadCurveExt {
    return new LoadCurveExt({
      annualConsumptionCalculated: dto.annualConsumptionCalculated,
      maximumHourlyConsumptionCalculated: dto.maximumHourlyConsumptionCalculated,
      values: dto.values,
      durationYear: dto.durationYear,
      startDate: dto.startDate && DtoExt.localeDateFromUtc(dto.startDate),
      stepMinutes: dto.stepMinutes
    } as any);
  }

  public annualConsumptionCalculated: number | null = null;

  public maximumHourlyConsumptionCalculated: number | null = null;

  public values: number[] | null = null;

  public durationYear: number | null = null;

  public startDate: Date | null = null;

  public unitRef: string | null = null;

  public stepMinutes: number | null = null;

  constructor(options?: Partial<LoadCurveExt>) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
      // this.annualConsumptionCalculated = options.annualConsumptionCalculated;
      // this.maximumHourlyConsumptionCalculated = options.maximumHourlyConsumptionCalculated;
      // this.values = options.values;
      // this.durationYear = options.durationYear;
      // this.startDate = options.startDate;
      // this.stepMinutes = options.stepMinutes;
      // this.unitRef = options.unitRef;
    }
  }

  public toDto(): LoadCurve {
    return new LoadCurve({
      annualConsumptionCalculated: this.annualConsumptionCalculated,
      maximumHourlyConsumptionCalculated: this.maximumHourlyConsumptionCalculated,
      values: this.values,
      durationYear: this.durationYear,
      startDate: DtoExt.localeDateToUtc(this.startDate),
      stepMinutes: this.stepMinutes
    });
  }
}
